const headerScripts = {
    loadWithoutDelay: [
      {
        el: "script",
        src: "https://www.googleoptimize.com/optimize.js?id=OPT-KK7Z7SF",
      },
    ],
    loadWithDelay: [
      {
        el: "script",
        src: "https://www.googletagmanager.com/gtag/js?id=UA-71763465-1",
      },
      {
        el: "script",
        src: "https://www.googletagmanager.com/gtag/js?id=AW-474915276",
      },
      {
        el: "script",
        src: "https://www.googletagmanager.com/gtag/js?id=AW-796001856",
      },
      {
        el: "script",
        src: "https://www.googletagmanager.com/gtag/js?id=G-SZ454CLTZM",
      },
      {
        el: "script",
        textNode: `(function(w,d,s,l,i){w[l]=w[l]||[];w[l].push({'gtm.start':
          new Date().getTime(),event:'gtm.js'});var f=d.getElementsByTagName(s)[0],
          j=d.createElement(s),dl=l!='dataLayer'?'&l='+l:'';j.async=true;j.src=
          'https://www.googletagmanager.com/gtm.js?id='+i+dl;f.parentNode.insertBefore(j,f);
          })(window,document,'script','dataLayer','GTM-TH3MQN4')`,
      },
      {
        el: "script",
        textNode: `window.dataLayer = window.dataLayer || [];
          function gtag(){dataLayer.push(arguments);}
          gtag('js', new Date());
          gtag('config', 'UA-71763465-1', { 'optimize_id': 'GTM-WDSZVB6'});`,
      },
  
      {
        el: "script",
        textNode: `window.dataLayer = window.dataLayer || [];
          function gtag(){dataLayer.push(arguments);}
          gtag('js', new Date());
          gtag('config', 'AW-474915276');`,
      },
  
      {
        el: "script",
        textNode: `window.dataLayer = window.dataLayer || [];
          function gtag(){dataLayer.push(arguments);}
          gtag('js', new Date());
          gtag('config', 'AW-796001856');`,
      },
      {
        el: "script",
        textNode: `(function(c,l,a,r,i,t,y){
      c[a]=c[a]||function(){(c[a].q=c[a].q||[]).push(arguments)};
      t=l.createElement(r);t.async=1;t.src="https://www.clarity.ms/tag/"+i;
      y=l.getElementsByTagName(r)[0];y.parentNode.insertBefore(t,y);
      })(window, document, "clarity", "script", "ayq955frd2")`,
      },
      {
        el: "script",
        textNode: `!function(f,b,e,v,n,t,s)
          {if(f.fbq)return;n=f.fbq=function(){n.callMethod?
          n.callMethod.apply(n,arguments):n.queue.push(arguments)};
          if(!f._fbq)f._fbq=n;n.push=n;n.loaded=!0;n.version='2.0';
          n.queue=[];t=b.createElement(e);t.async=!0;
          t.src=v;s=b.getElementsByTagName(e)[0];
          s.parentNode.insertBefore(t,s)}(window, document,'script',
          'https://connect.facebook.net/en_US/fbevents.js');
          fbq('init', '667972674466261');
          fbq('track', 'PageView');`,
      },
      {
        el: "script",
        textNode: `window.fbAsyncInit = function() {
              FB.init({
                appId      : '534961220012939',
                xfbml      : true,
                version    : 'v2.5'
              });
          };
          (function(d, s, id) {
              var js, fjs = d.getElementsByTagName(s)[0];
              if (d.getElementById(id)) {return;}
              js = d.createElement(s); js.id = id;
              js.src = "//connect.facebook.net/en_US/sdk.js";
              fjs.parentNode.insertBefore(js, fjs);
          }(document, 'script', 'facebook-jssdk'));`,
      },
      {
        el :"script",
        textNode:`(function() {
            var a = String(Math.floor(Math.random() * 10000000000000000));
            new Image().src = 'https://pubads.g.doubleclick.net/activity;xsp=4913148;ord='+ a +'?';
          })();`,
        url:"courses/dsa-self-paced"
    },
    {
        el :"script",
        textNode:`(function() {
            var a = String(Math.floor(Math.random() * 10000000000000000));
            new Image().src = 'https://pubads.g.doubleclick.net/activity;xsp=4913151;ord='+ a +'?';
          })();`,
        url:"payments/dsa-self-paced"
    }
    ],
  };
  export default headerScripts;
  
